import './touringstep.less'

import {Form, Formik} from 'formik'
import {TourKey, TourModel} from 'models/configuration/TourModel'
import {TrackModel} from 'models/configuration/TrackModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepKey} from 'models/registration/StepModel'
import React from 'react'
import {useHistory} from 'react-router'
import {FormikChanges} from 'util/formikchanges'
import {style} from 'util/style'
import {FormField} from 'views/form/form'
import {Info} from 'views/layout/info'
import {Step} from 'views/registration/step'

const styles = style('touringstep', ['category'])

export const TouringStep: React.FC<{
	step: StepKey
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = attrs => {
	const {registration, updateRegistration} = attrs
	const step = registration.allSteps.touring
	const history = useHistory()
	return (
		<Formik<{tours: Array<TourKey>}>
			initialValues={{tours: step.tours}}
			onSubmit={() => {
				history.push(`#${step.nextStepKey}`)
			}}
		>
			<Form>
				<FormikChanges
					onChange={({values}, setValues) => {
						const newRegistration = step.setTours(values.tours || [])
						updateRegistration(newRegistration)
						setValues({tours: newRegistration.state.tours})
					}}
				/>
				<Step step={step} hasFormSubmit={true}>
					<div className={styles}>
						{step.tracks.map(track => (
							<TouringStepCategory track={track} />
						))}
					</div>
				</Step>
			</Form>
		</Formik>
	)
}

export const TouringStepCategory: React.FC<{
	track: TrackModel
}> = ({track}) => {
	return (
		<div className={styles.category()}>
			<h3 className={styles.category('title')}>{track.label}</h3>
			<div className={styles.category('options')}>
				{track.tours.map(tour => {
					return (
						<div className={styles.category('options-item')}>
							<FormField
								type="checkbox"
								mod={{disabled: tour.isFull}}
								disabled={tour.isFull}
								label={
									<span>
										{tour.label}|{tour.time} {tour.isFull && ' [Fully booked] '}
										{tour.popup && (
											<Info label={tour.label} popup={tour.popup} />
										)}
									</span>
								}
								name="tours"
								value={tour.key}
							/>
						</div>
					)
				})}
			</div>
		</div>
	)
}
